import { connect } from 'react-redux';
import { entitySelectors } from '@store/entity/selectors';
import { guestSelectors } from '@store/guest/selectors';
import { signIn } from '@store/guest/actions';
import { NormalizedStore } from '@store/entity/entity.types';

import { DispatchProps, StateProps } from './SignIn.types';
import SignIn from './SignIn';

const mapStateToProps: (state: NormalizedStore) => StateProps = (state) => ({
  isSignedIn: !!guestSelectors.getGuest(state),
  property: entitySelectors.getProperty(state),
  propertyId: entitySelectors.getProperty(state).id,
});

const mapDispatchToProps: DispatchProps = {
  signIn,
};

const _connected: any = connect(mapStateToProps, mapDispatchToProps)(SignIn);
export default _connected;
